if (!customElements.get("m-recently-viewed")) {
  class MRecentlyViewed extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper", // slideContainer
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.items = this.dataset.productsPerRow;
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";
      this.productsToshow = parseInt(this.dataset.productsToShow);

      console.log('Component Initialization:', {
        dataset: {
          enableSlider: this.dataset.enableSlider,
          showPagination: this.dataset.showPagination,
          showNavigation: this.dataset.showNavigation,
          productsPerRow: this.dataset.productsPerRow,
          mobileDisableSlider: this.dataset.mobileDisableSlider,
          productsToShow: this.dataset.productsToShow
        },
        parsedValues: {
          enableSlider: this.enableSlider,
          showPagination: this.showPagination,
          showNavigation: this.showNavigation,
          items: this.items,
          mobileDisableSlider: this.mobileDisableSlider,
          productsToshow: this.productsToshow
        }
      });

      this.init();
    }

    init() {
      fetch(this.dataset.url + this.getQueryString())
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("m-recently-viewed");
          this.products = recommendations.querySelectorAll(".m-product-card").length;
          if (this.products > 0) {
            this.classList.remove("m:hidden");
          }
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.initByScreenSize();
            document.addEventListener("matchMobile", () => {
              this.initByScreenSize();
            });
            document.addEventListener("unmatchMobile", () => {
              this.initByScreenSize();
            });

            MinimogTheme.CompareProduct?.setCompareButtonsState();
            MinimogTheme.Wishlist?.setWishlistButtonsState();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);

      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        slideControls && slideControls.classList.add("m:hidden");
        slideContainer && slideContainer.classList.remove("swiper-container");
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        slideControls && slideControls.classList.remove("m:hidden");
        this.initSlider();
      }

      if (this.products <= parseInt(this.items)) {
        slideControls && slideControls.classList.add("m:hidden");
      }
    }

    initSlider() {
      const { slideContainer } = queryDomNodes(this.selectors, this);
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = slideContainer.querySelector(".swiper-wrapper").childElementCount;

      // Show navigation if we have more items than visible slides and not on mobile
      const shouldShowNavigation = slideItemsLength > parseInt(this.items) && !MinimogTheme.config.mqlMobile;

      // Show/hide navigation controls based on item count and mobile state
      if (controlsContainer) {
        if (shouldShowNavigation) {
          controlsContainer.classList.remove("m:hidden");
          prevButton?.classList.remove("m:hidden");
          nextButton?.classList.remove("m:hidden");
        } else {
          controlsContainer.classList.add("m:hidden");
          prevButton?.classList.add("m:hidden");
          nextButton?.classList.add("m:hidden");
        }
      }

      slideContainer && slideContainer.classList.add("swiper-container");

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: 2.25,
        spaceBetween: 0,
        slidesPerGroup: 1,
        freeMode: true,
        freeModeMomentum: true,
        freeModeMomentumRatio: 0.5,
        freeModeMomentumVelocityRatio: 0.5,
        showPagination: this.showPagination,
        navigation: shouldShowNavigation ? {
          nextEl: nextButton,
          prevEl: prevButton,
          disabledClass: 'disabled'
        } : false,
        loop: false,
        pagination: this.showPagination
          ? {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          }
          : false,
        breakpoints: {
          768: {
            slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items),
            spaceBetween: 0,
            freeMode: false,
            slidesPerGroup: 1
          },
          1024: {
            slidesPerView: parseInt(this.items) >= 4 ? 4 : parseInt(this.items),
            spaceBetween: 0,
            freeMode: false,
            slidesPerGroup: 1
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: 0,
            freeMode: false,
            slidesPerGroup: 1
          },
        },
        threshold: 2,
        on: {
          init: () => {
            setTimeout(() => {
              // Calculate controls position
              const firstItem = this.querySelector(".m-image") || this.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                if (shouldShowNavigation) {
                  // Hide prev button initially since we're at the start
                  prevButton?.classList.add("m:hidden");
                  nextButton?.classList.remove("m:hidden");
                }
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              const shouldShowControls = slideItemsLength > slidesPerView && !MinimogTheme.config.mqlMobile;
              
              if (shouldShowControls) {
                controlsContainer.classList.remove("m:hidden");
                prevButton?.classList.remove("m:hidden");
                nextButton?.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                prevButton?.classList.add("m:hidden");
                nextButton?.classList.add("m:hidden");
                swiper.allowTouchMove = true;
              }
            }
          },
          slideChange: (swiper) => {
            if (controlsContainer && !MinimogTheme.config.mqlMobile) {
              // Hide prev button if we're at the start
              if (swiper.isBeginning) {
                prevButton?.classList.add("m:hidden");
              } else {
                prevButton?.classList.remove("m:hidden");
              }
              
              // Hide next button if we're at the end
              if (swiper.isEnd) {
                nextButton?.classList.add("m:hidden");
              } else {
                nextButton?.classList.remove("m:hidden");
              }
            }
          }
        },
      });

      if (this.slider) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }

      this.swiper = slideContainer && slideContainer.swiper;
    }

    getQueryString() {
      const cookieName = "minimog-recently-viewed";
      const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
      if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
        items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
      }
      return items
        .map((item) => "id:" + item)
        .slice(0, this.productsToshow)
        .join(" OR ");
    }
  }
  customElements.define("m-recently-viewed", MRecentlyViewed);
}
